import React, { useEffect, useState } from "react";
import { Form, Select } from "antd";
import Label from "src/components/label/label.component";
import CustomInput from "src/components/custom-input/custom-input.component";
import { PhoneInput } from "react-international-phone";
import ReactCountryFlag from "react-country-flag";
import { toast } from "react-hot-toast";
import instance from "src/store/axios";
import { AxiosResponse } from "axios";
import CustomerService from "../customers-list/customer.service";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getStandingDataOptions } from "src/utils/helper/functions";
import CustomModal from "src/components/custom-modal/custom-modal";

const { Option } = Select;

const CreateCustomerPage = () => {
  const customerServiceInstance = new CustomerService();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get("customerId");
  const [form] = Form.useForm();
  const [countriesData, setCountriesData] = useState([]);
  const [standingData, setStandingData] = useState<any>();
  const [existingUsers, setExistingUsers] = useState<any[]>([]);
  const [openExistingUsersModal, setOpenExistingUsersModal] = useState<boolean>(false);

  useEffect(() => {
    getCountriesData();
    getStandindData();
  }, []);

  const getCountriesData = async (): Promise<void> => {
    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION
        }/option/countries?partial=${1}`
      );
      setCountriesData(response.data.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/home/create-customer`);
    }
  };

  const getStandindData = async (): Promise<void> => {
    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/option/standing-data`
      );
      setStandingData(response.data.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/home/create-customer`
      );
    }
  };

  const onSubmit = async (values: any): Promise<void> => {
    const body: any = {
      accountType: 22,
      accountSubType: values.saudiAccountType == 431 ? 21 : 20,
      nationality: values.nationality,
      residentialCountry: values.residentialCountry,
    };

    if (customerId) {
      body.userId = +customerId;
    } else {
      body.createAccessAccount = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        phoneNumber: values.phoneNumber?.replace(" ", ""),
      }
    }

    try {
      const result = await customerServiceInstance.createCustomer(body);
      if (result?.alreadyExists && result?.users?.length) {
        setExistingUsers(result.users);
        setOpenExistingUsersModal(true);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "An error occurred");
    }
  };

  const handleSelectExistingUser = (userId: number) => {
    setOpenExistingUsersModal(false);
    navigate(`/home/create-customer?customerId=${userId}`);
  };

  return (
    <div className="flex gap-5 flex-col bg-white rounded-lg p-5 create-customer-form-container">
      <div className="border-b-[1px] border-zinc-300 pb-3">
        <p className=" text-black text-base font-bold">
          Create an account (Individual)
        </p>
      </div>

      <Form form={form} onFinish={onSubmit} scrollToFirstError={true}>
        <div className="flex justify-between flex-wrap ">
          {!customerId && <div className="flex flex-col w-full md:w-[49%]">
            <Label text="First name" required />
            <Form.Item
              name="firstName"
              rules={[
                {
                  required: true,
                  message: "Please input first name!",
                },
              ]}
            >
              <CustomInput placeholder="Enter first name" />
            </Form.Item>
          </div>}
          {!customerId && <div className="flex flex-col w-full md:w-[49%]">
            <Label text="Last name" required />
            <Form.Item
              name="lastName"
              rules={[
                {
                  required: true,
                  message: "Please input last name!",
                },
              ]}
            >
              <CustomInput placeholder="Enter last name" />
            </Form.Item>
          </div>}
          {!customerId && <div className="flex flex-col w-full md:w-[49%]">
            <Label text="Mobile number" required />
            <Form.Item
              name="phoneNumber"
              rules={[
                {
                  required: true,
                  message: "Please input your mobile number!",
                },
                {
                  validator: (_: any, value: string) => {
                    if (!value) return Promise.resolve();
                    const digits = value.replace(/\D/g, "");
                    if (digits.startsWith("966") && digits.length !== 12) {
                      return Promise.reject(
                        "Phone number must be 9 digits after country code"
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <div className="phone-input">
                <PhoneInput
                  placeholder="Enter mobile number"
                  value={undefined}
                  defaultCountry="sa"
                />
              </div>
            </Form.Item>
          </div>}
          {!customerId && <div className="flex flex-col w-full md:w-[49%]">
            <Label text="Email" required />
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please input email!",
                },
                {
                  type: "email",
                  message: "Please enter valid email!",
                },
              ]}
            >
              <CustomInput placeholder="Enter email" />
            </Form.Item>
          </div>}
          <div className="field flex-col w-full md:w-[49%]">
            <Label text="Nationality" required />
            <Form.Item
              name="nationality"
              rules={[
                {
                  required: true,
                  message: "Please select nationality!",
                },
              ]}
            >
              <Select
                placeholder="Select Nationality"
                allowClear
                showSearch
                filterOption={(input, option: any) => {
                  return (option?.key.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  );
                }}
              >
                {countriesData.map((country: any) => (
                  <Option value={country.id} key={country.nameEn}>
                    <div className="flex align-center" style={{ gap: "5px" }}>
                      <ReactCountryFlag
                        style={{
                          fontSize: "24px",
                          marginInlineEnd: "8px",
                        }}
                        countryCode={country?.countryCode}
                        svg
                      />
                      <span>{country.nameEn}</span>
                    </div>
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="field flex-col w-full md:w-[49%]">
            <Label text="Residence" required />
            <Form.Item
              name="residentialCountry"
              rules={[
                {
                  required: true,
                  message: "Please select residence!",
                },
              ]}
            >
              <Select
                placeholder="Select Residence"
                allowClear
                showSearch
                filterOption={(input, option: any) => {
                  return (option?.key.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  );
                }}
              >
                {countriesData.map((country: any) => (
                  <Option value={country.id} key={country.nameEn}>
                    <div className="flex align-center" style={{ gap: "5px" }}>
                      <ReactCountryFlag
                        style={{
                          fontSize: "24px",
                          marginInlineEnd: "8px",
                        }}
                        countryCode={country?.countryCode}
                        svg
                      />
                      <span>{country.nameEn}</span>
                    </div>
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="field flex-col w-full md:w-[49%]">
            <Label text="Account type" required />
            <Form.Item
              name="saudiAccountType"
              rules={[
                {
                  required: true,
                  message: "Please select account type",
                },
              ]}
            >
              <Select
                placeholder="Select account type"
                options={[
                  ...getStandingDataOptions(
                    standingData,
                    "SaudiClientType",
                    ["sa", "gc"],
                    false
                  ),
                ]}
              />
            </Form.Item>
          </div>
        </div>
        <div className="flex items-center justify-end w-full mt-9">
          <div className="flex justify-between items-center w-full md:w-1/2">
            <button
              type="button"
              onClick={() => {
                navigate("/home/customers-list");
              }}
              className="border-[1px] rounded-xl py-3 border-blue-500 text-blue-500 w-[49%] font-semibold"
            >
              Cancel
            </button>
            <button
              type="submit"
              onClick={() => {
                console.log(form.getFieldsValue());
                console.log(form.getFieldsError());
              }}
              className="border-[1px] rounded-xl border-blue-500 bg-blue-500 text-white w-[49%] py-3 disabled:opacity-50 disabled:cursor-not-allowed font-semibold"
            >
              Confirm
            </button>
          </div>
        </div>
      </Form>

      <CustomModal
        isVisible={openExistingUsersModal}
        centered
        width={620}
        showClose={true}
        onClose={() => setOpenExistingUsersModal(false)}
        className="existing-users-modal"
      >
        <div className="flex flex-col p-6 pb-0">
          <div className="flex flex-col items-center text-center mb-5">
            <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mb-3">
              <img
                src="/images/info.svg"
                alt="info"
                className="w-10 h-10"
              />
            </div>
            <h3 className="text-lg font-bold text-black mb-1">
              {existingUsers.length === 1
                ? "Existing account found"
                : "Existing accounts found"}
            </h3>
            <p className="text-gray-500 text-sm max-w-md">
              {existingUsers.length === 1
                ? "We found an existing user matching the provided information. Continue to create the customer for this account."
                : `We found ${existingUsers.length} users matching the provided information. Select an account to continue creating the customer for it.`}
            </p>
          </div>

          <div className="flex flex-col gap-3 max-h-[380px] overflow-y-auto pr-1">
            {existingUsers.map((user: any) => (
              <div
                key={user.id}
                className="group flex items-center justify-between p-4 border border-gray-200 rounded-xl hover:border-blue-500 hover:shadow-md transition-all"
              >
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-white font-semibold text-sm shadow-sm">
                    {(user.firstName?.[0] || "").toUpperCase()}
                    {(user.lastName?.[0] || "").toUpperCase()}
                  </div>
                  <div className="flex flex-col">
                    <p className="text-sm font-semibold text-black leading-tight">
                      {user.firstName} {user.lastName}
                    </p>
                    <p className="text-xs text-gray-500 mt-0.5">{user.email}</p>
                    <p className="text-xs text-gray-500">{user.phone}</p>
                  </div>
                </div>
                {existingUsers.length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleSelectExistingUser(user.id)}
                    className="rounded-lg bg-blue-500 px-5 py-2 text-white text-xs font-semibold hover:bg-blue-600 transition-colors shadow-sm"
                  >
                    Select
                  </button>
                )}
              </div>
            ))}
          </div>

          {existingUsers.length === 1 && (
            <div className="flex justify-center gap-3 mt-6">
              <button
                type="button"
                onClick={() => setOpenExistingUsersModal(false)}
                className="rounded-lg bg-white min-w-[160px] px-10 py-2.5 text-blue-500 text-sm font-semibold border-[1px] border-blue-500 hover:bg-blue-50 transition-colors"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={() => handleSelectExistingUser(existingUsers[0].id)}
                className="rounded-lg bg-blue-500 min-w-[160px] px-10 py-2.5 text-white text-sm font-semibold hover:bg-blue-600 transition-colors shadow-sm"
              >
                Continue
              </button>
            </div>
          )}
        </div>
      </CustomModal>
    </div>
  );
};

export default CreateCustomerPage;
